import { X } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";
import { fieldActionMessage } from "@/lib/appointment-field-actions";
import { cancelAppointment } from "@/services/appointment-cancellation.service";
import { CANCELLABLE_STATUSES } from "@/lib/appointment-cancellation";

export class CancelAction extends BaseAppointmentAction {
    readonly config = {
        id: "cancel",
        label: "Cancel",
        description: "Cancel appointment (PMC only)",
        icon: X,
        category: AppointmentActionCategory.STATUS,
        permissions: {
            requiredRole: [UserRole.PMC],
            requiredStatuses: [...CANCELLABLE_STATUSES]
        },
        requiresDialog: true,
        variant: "destructive" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        // No payload validation needed for cancel
        return null;
    }

    getDialogComponent(): string {
        return "CancelDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            if (context.userRole === UserRole.PMC) {
                await cancelAppointment(context.appointmentId);

                return {
                    success: true,
                    message: "Appointment cancelled successfully"
                };
            }

            return {
                success: false,
                message: "Vendors cannot cancel directly. Use 'Request Cancellation' instead."
            };
        } catch (error) {
            return {
                success: false,
                message: fieldActionMessage(error, "Failed to cancel appointment")
            };
        }
    }
}